import React from "react";

import background from '@cover/stillestoppen/background-1.jpg';
import backgroundSm from '@cover/stillestoppen/background-1-sm.jpg';
import background2 from '@cover/stillestoppen/background-2.png';
import background2Sm from '@cover/stillestoppen/background-2-sm.png';
import StilleStoppen from "../components/cover/animations/stillestoppen";

import eyeSrc from '@assets/eye.svg';
import soundSrc from '@assets/sound.svg';

export const meta = {
	category: "stop",
	slug: "stille",
	id: "StilleStoppen",
	excerpt: {
		before: "Der Gambist Matthias Bergmann aus Mannheim ist einer von sieben Gewinnern des ",
		italic: "Klangspektrums ",
		after: "Baden-Württemberg in der Kategorie Klassik."
	},
	name: "stillestoppen",
	title: "Die Sprache der Musik",
	animation: StilleStoppen,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		layers: [
			{
				src: {
					lg: background2,
					sm: background2Sm
				},
				zIndex: 666,
			}
		],
		alt: "Matthias Bergmann hält sein Instrument, die Gambe, in der Hand. Feine, leuchtende Schallwellen umgeben sie und den Schriftzug 'spüren und hören'."
	}
}

const StillestoppenArticle = () => {
	return (
		<div>
			<p className="articleStatement">
				« Musik ist eine sehr wirkungsvolle Sprache, die nicht
				den Umweg über den Intellekt nimmt, sondern direkt
				die Menschen erreicht: Man spürt und hört die Musik
				ganz unmittelbar. Sie schafft dabei eine enge Verbindung
				zwischen Komponist, Musikern und Zuhörern. Alles was
				einen Menschen bewegen kann, ob es mit Worten sagbar
				ist oder nicht, kann mit Musik ausgedrückt werden.
				Sogar das, was man rational gar nicht versteht. Musik
				kann auch eine eigene Welt erschaffen. Dort ist zwar
				alles Menschliche enthalten, aber reiner, und alles was
				in der materiellen Sphäre nicht perfekt ist, zählt nicht.
				Musik kann Jahrhunderte überdauern, aber gleichzeitig
				entsteht und vergeht sie in Augenblicken und existiert
				nur in den Momenten, in denen die Zeit aufgehoben ist. »
			</p>
			<p className="articleHint">
				Der Gambist Matthias Bergmann aus
				Mannheim ist einer von sieben Gewinnern
				des Klangspektrums Baden-Württemberg
				in der Kategorie Klassik.
			</p>
			<a href="https://klangspektrum-bw.de/" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={soundSrc} />
				</div>
				<div>
					Klangspektrum BW
					<div className="articleLinkSource">
						klangspektrum-bw.de
					</div>
				</div>
			</a>
			<a href="https://www.ardmediathek.de/video/event-gala/die-gewinner-und-ihre-musikstuecke/swrfernsehen-de/Y3JpZDovL3N3ci5kZS9hZXgvbzEzNTI2MzU/" target="_blank" className="articleLink articleLink--block">
			 	<div className="articleLinkIcon">
					<img src={eyeSrc} />
				</div>
				<div>
					Klangspektrum BW – Die Gewinner und ihre Musikstücke
					<div className="articleLinkSource">
						SWR Mediathek
					</div>
				</div>
			</a>
		</div>
	)
};

export default StillestoppenArticle;